import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getAdvertisementByGuid, getActiveAdvertisements } from '../../api/advertisementService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { FaCalendarAlt, FaBuilding, FaMapMarkerAlt, FaFileDownload } from 'react-icons/fa';

const AdvertisementDetail = () => {
  const [advertisement, setAdvertisement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { urlTag } = useParams();
  const guidFromState = location.state?.guid;

  const fetchAdvertisementDetail = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      let guid = guidFromState;

      // Eğer state'den guid gelmemişse (direkt URL girişi), urlTag ile bul
      if (!guid && urlTag) {
        console.log('GUID not found in state, fetching by urlTag:', urlTag);
        const allAdvertisementsResponse = await getActiveAdvertisements(1, 1000);
        
        if (allAdvertisementsResponse.isSuccess && allAdvertisementsResponse.data?.items) {
          const foundAdvertisement = allAdvertisementsResponse.data.items.find(
            item => item.urlTag === urlTag
          );
          
          if (foundAdvertisement) {
            guid = foundAdvertisement.guid;
            console.log('Found advertisement with guid:', guid);
          } else {
            console.log('Advertisement not found with urlTag:', urlTag);
            setError('İlan bulunamadı');
            setLoading(false);
            return;
          }
        } else {
          console.log('Failed to fetch advertisements list');
          setError('İlanlar yüklenirken bir hata oluştu');
          setLoading(false);
          return;
        }
      }

      if (!guid) {
        console.log('No guid available');
        setError('İlan bilgisi bulunamadı');
        setLoading(false);
        return;
      }

      console.log('Fetching advertisement detail for guid:', guid);
      const response = await getAdvertisementByGuid(guid);
      console.log('Advertisement detail response:', response);
      
      if (response.isSuccess && response.data) {
        setAdvertisement(response.data);
        setError(null);
      } else {
        setError(`İlan detayı yüklenirken bir hata oluştu: ${JSON.stringify(response)}`);
      }
    } catch (error) {
      console.error('Error in fetchAdvertisementDetail:', error);
      setError(`İlan detayı yüklenirken bir hata oluştu: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [urlTag, guidFromState]);

  useEffect(() => {
    fetchAdvertisementDetail();
  }, [fetchAdvertisementDetail]);

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: tr });
    } catch (error) {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="advertisements-detail-page">
        <div className="container py-5 advertisement-detail-container">
          <div className="loading">Yükleniyor...</div>
        </div>
      </div>
    );
  }

  if (error || !advertisement) {
    return (
      <div className="advertisements-detail-page">
        <div className="container py-5 advertisement-detail-container">
          <div className="alert alert-danger">{error || 'İlan bulunamadı'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="advertisements-detail-page">
      <div className="container py-5 advertisement-detail-container">
        <div className="row">
          <div className="col-md-12">
            <div className="advertisements-detail-card">
              <div className="detail-header">
                <h2>{advertisement.header}</h2>
                
                <div className="detail-meta-grid">
                  <div className="meta-item">
                    <FaBuilding />
                    <span className="meta-label">Birim:</span>
                    <span>{advertisement.department || 'Belirtilmemiş'}</span>
                  </div>
                  
                  <div className="meta-item">
                    <FaCalendarAlt />
                    <span className="meta-label">Tarih:</span>
                    <span>{formatDate(advertisement.date)}</span>
                  </div>

                  {advertisement.address && (
                    <div className="meta-item">
                      <FaMapMarkerAlt />
                      <span className="meta-label">Adres:</span>
                      <span>{advertisement.address}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="detail-body-section">
                <h3>İlan Metni</h3>
                <div className="detail-text" dangerouslySetInnerHTML={{ __html: advertisement.detail }} />
              </div>

              {advertisement.fileUrl && (
                <div className="detail-action-section">
                  <a href={advertisement.fileUrl} target="_blank" rel="noopener noreferrer" className="download-btn">
                    <FaFileDownload />
                    <span>Dokümanı İndir</span>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementDetail;
